// src/components/RouteMemory.jsx

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RouteMemory() {
  const location = useLocation();
  const { user, authReady } = useAuth();

  useEffect(() => {
    if (!authReady || !user) return;

    const path = location.pathname + location.search;

    const ignoredPaths = [
      "/",
      "/login",
      "/register",
      "/driver-register",
      "/forgot-password",
      "/verify-email",
      "/auth/callback",
      "/reset-password",
      "/payment/return",
    ];

    if (!ignoredPaths.includes(location.pathname)) {
      sessionStorage.setItem("uniair_last_private_route", path);
    }
  }, [authReady, user, location.pathname, location.search]);

  return null;
}